import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ChatbaseWidget from "@/components/ChatbaseWidget";
import "@/App.css";

import Landing from "@/pages/Landing";
import ExpositorWizard from "@/pages/ExpositorWizard";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminStandDetail from "@/pages/AdminStandDetail";
import AuthCallback from "@/pages/AuthCallback";
import ServiciosOficiales from "@/pages/ServiciosOficiales";
import MisEspacios from "@/pages/MisEspacios";
import AdminEditBanner from "@/components/AdminEditBanner";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <AdminEditBanner />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/expositor" element={<Navigate to="/" replace />} />
        <Route path="/stand/:code" element={<ExpositorWizard />} />
        <Route path="/mis-espacios" element={<MisEspacios />} />
        <Route path="/servicios/:code" element={<ServiciosOficiales />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/stand/:id" element={<AdminStandDetail />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
        <ChatbaseWidget />
        <Toaster theme="dark" position="top-right" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
